<!--  -->
<template>
  <div
    id="print"
    :class="['training', 'training-blockly-content', { mark: beMark }]"
  >
    <div class="training-head"></div>
    <Editor-head
      :project-id="projectId"
      :editorId="editorId"
      :Project.sync="Project"
      @saveFile="saveFile"
      @onExecution="onExecution"
      
    ></Editor-head>
    <div class="training-area">
      <!-- :运行区模块   -->
      <div class="training-right-side">
        <code-run
          :codeText="codeText"
          @runHandle="runHandle"
          @sidebarSwitchHandle="sidebarSwitchHandle"
          :Project.sync="Project"
          :project-id="projectId"
          ref="codeRun"
          v-bind="$attrs"
          v-on="$listeners"
        />
      </div>
      <blockly-editer-index
        :project-id="projectId"
        :training-id="trainingId"
        :Media="Media"
        :blockXmlText="blockXmlText"
        :xml-data="{
          name: Project.projectName,
          type: 1,
          path: Project.blocksFileUrl,
        }"
        :save-flag="saveFlag"
        ref="blocklyIndex"
      >
      </blockly-editer-index>
    </div>
    <!-- <block- -->
    <div class="popup-list popup-list3">
      <!-- 不创建项目提示：继续创建在本页面，取消则退回上一页 -->
      <gat-popup
        :class="['popup-execution', popupActive === 'execution' ? 'on' : 'off']"
        :title="''"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="executionProject"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span class="title">是否退出新建项目？</span>
            </div>

            <div class="content">确定退出将返回首页</div>
          </div>
        </template>
      </gat-popup>
      <!-- 离开时保存提示弹框 -->
      <gat-popup
        :class="[
          'popup-leave-save',
          popupActive === 'leave-save' ? 'on' : 'off',
        ]"
        :title="'是否保存项目？'"
        :primary-button="'确定'"
        :cancel-button="'否'"
        @cancel="confirmLeaveSave"
        @confirm="confirmLeaveSave(true)"
      >
        <template v-slot:content>
          <span></span>
        </template>
      </gat-popup>
    </div>
    <guide-tool :path="hashId"></guide-tool>
  </div>
</template>

<script>
import EditorHead from '@/views/projects/components/EditorHead.vue'
import BlocklyEditerIndex from '@/components/blocklyEditor/EditorIndex.vue'
// import PROJECTS from '@/axios/trainingCenter/projects/projects.js'
// import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js'
import AIBLOCK from '@/axios/personalSpace/AiEditor/blocks.js'
import PERSONAL from '@/axios/personalSpace/personalSpace.js'
import codeRun from '@/components/blocklyEditor/common/codeRun.vue'
import GatPopup from '@/components/common/GatPopup'
import GuideTool from '@/components/guide/GuideTool.vue'
import AI_EDITOR from '@/axios/personalSpace/AiEditor/blocks.js'
import { mapGetters } from 'vuex'
import bus from '@/utils/bus'
import { debounce } from 'lodash'
export default {
  name: 'BlocklyHome',
  components: { EditorHead, BlocklyEditerIndex, GatPopup, codeRun, GuideTool },
  props: ['trainingId', 'createBy'],
  data() {
    return {
      Blocks: { TotalCount: 0, Items: [] },
      Media: [],
      projectId: '',
      editorId: '',
      scoreHandle: false,
      studentId: '',
      hashId: 'blockly-editor',
      workspaceIsVisible: true,
      homeWorkStatus: false,
      beMark: false, //遮罩层
      hasAttr: false,
      trainingDetails: { status: 2 }, // 需要从接口获取
      reportInfo: {}, //实训报告信息
      Project: {
        //项目信息存储
        projectId: '00000000-0000-0000-0000-000000000000',
        projectName: '',
        blocksFileUrl: '',
      },
      blockXmlText: '',
      // 边框开关
      sidebarSwitch: true,
      popupActive: '',
      routePath: '', //跳转的路由来源
      saveFlag: 0, // 保存后没有修改，或打开后没有修改
      searchKey: '',
      isPublic: 1, //1完成，0未完成
      leaveType: '', //跳转的路由来源
      scored: null, //判断是否已评分状态进来
      score: null, //具体分数
      codeText: '', //运行结果，在runCode组件中处理;
      rightSideVal: 'guideBook',
      iconSubmitCode: require('@/assets/images/ai-editor/submit-code.png'),
      iconExercise: require('@/assets/images/ai-editor/submit-exercise.png'),
      switchIcon: require('@/assets/images/ai-editor/switch.png'),
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
    }
  },
  provide() {
    return {
      blockSData: this.Blocks,
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(['accountInfo', 'hasRunSuccess', 'curriculumId', 'userRole']),
  },
  //监控data中的数据变化
  watch: {},

  async created() {
    let self = this
    let query = this.$route.query
    if (query) {
      //全局变量，判断是否为老师角色从评分进来
      this.projectId = query.projectId
      this.editorId = query.editorId
      this.$store.state.blocklyHome.createBy = query.createBy
      console.log('projectId', this.projectId)
    }
    this.getMedia()
    //离开前监听
    bus.$on('beforeLeave', async (type) => {
      self.leaveType = type
      self.beforeLeave()
    })

    //监听 切换右侧工具栏的显示;
    bus.$on('changeRightSide', (val) => {
      self.rightSideVal = val
    })
    //监听 显示积木工作区
    bus.$on('changeWorkspace', (val) => {
      self.workspaceIsVisible = val
    })
    console.log('created---------')
  },

  async mounted() {
    let self = this,
      projectQuestionRes,
      userId = this.accountInfo.userId,
      socket_basis = window.gtaAiConfig.socket_basis,
      wsUrl = `${socket_basis}${userId}`
    this.homeWorkStatus = this.$store.state.blocklyHome.homeWorkStatus
    console.log('mounted---------')
    //获取积木列表
    await this.getBlockList()
    if (this.$refs) {
      this.$refs.blocklyIndex.$refs.blockly
        .GetDefUserBlockList()
        .then((res) => {
          this.getProjectByProjectId()
        })
    } else {
      setTimeout(() => {
        this.$refs.blocklyIndex.$refs.blockly
          .GetDefUserBlockList()
          .then((res) => {
            this.getProjectByProjectId()
          })
      }, 500)
    }

    // bus.$emit('GetDefUserBlockList') //调用自定义积木列表
    // if (this._isMobile()) {
    //   // plus.screen.lockOrientation( 'landscape-primary');
    //   // 移动端设置横屏
    //   // this.mobileEngines()
    // } else {
    //   // alert("pc端");
    // }
  },
  beforeDestroy() {
    this.scoreHandle = false
    this.studentId = null
    this.$store.state.blocklyHome.studentId = null
    // this.$store.state.blocklyHome.scoreHandle = null;
    this.$store.state.blocklyHome.hasRunSuccess = null
    // this.$store.state.blocklyHome.curriculumId = null;
    // this.$store.state.blocklyHome.homeWorkStatus = null;
    //  bus.$off("changeMode");
    bus.$off('changeRightSide')
    bus.$off('changeWorkspace')
  },
  methods: {
    // 判断是否移动端设备
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    // 移动端设置横屏
    mobileEngines() {
      var width = document.documentElement.clientWidth
      var height = document.documentElement.clientHeight
      if (width < height) {
        // console.log(width + ' ' + height)
        let print = document.querySelector('#print')
        // print.style['width'] = height + 'px'
        // print.style['height'] = width + 'px'
        // print.style['top'] = (height - width) / 2 + 'px'
        // print.style['left'] = (0 - (height-width) / 2 ) + 'px'
        // print.style['transform'] = 'rotate(90deg)'
        // print.style['transform-origin'] = '50% 50%'
        print.style.width = height + 'px'
        print.style.height = width + 'px'
        print.style.top = (height - width) / 2 + 'px'
        print.style.left = 0 - (height - width) / 2 + 'px'
        print.style.transform = 'rotate(90deg)'
        print.style.transformOrigin = '50% 50%'
      }

      var evt = 'onorientationchange' in window ? 'orientationchange' : 'resize'
      window.addEventListener(
        evt,
        function() {
          console.log('evt', evt)
          var width = document.documentElement.clientWidth
          var height = document.documentElement.clientHeight
          let print = document.querySelector('#print')
          if (width > height) {
            print.style.width = width + 'px'
            print.style.height = height + 'px'
            print.style.top = 0
            print.style.left = 0
            print.style.transform = 'none'
            print.style.transformOrigin = '50% 50%'
          } else {
            print.style.width = height + 'px'
            print.style.height = width + 'px'
            print.style.top = (height - width) / 2 + 'px'
            print.style.left = 0 - (height - width) / 2 + 'px'
            print.style.transform = 'rotate(90deg)'
            print.style.transformOrigin = '50% 50%'
          }
        },
        false
      )
    },
    beforeLeave() {
      let self = this
      this.popupActive = 'leave-save'
    },
    leavePage(data) {
      let deleteTrainingId,
        trainingId = this.trainingId
      if (!data || !data.deleteTrainingId) {
        return
      }
      deleteTrainingId = data.deleteTrainingId
      if (deleteTrainingId === trainingId && this.userRole === 2) {
        this.$message.warning('该课程实训已被撤回或删除，页面将5s后退出')
        setTimeout(() => {
          this.confirmLeaveSave(false)
        }, 5000)
      }
    },
    async confirmLeaveSave(val) {
      let leaveType = this.leaveType
      let editorId = this.editorId
      // 点击删除按钮时，不退出页面，弹框消失；
      if (!val || val === 'firstOff') {
        // if (!val||val === 'firstOff') {
        return (this.popupActive = '')
      }
      if (val === true) {
        let result = await this.saveFile() //保存项目
      }
      //退出操作
      switch (leaveType) {
        case 'back': {
          this.$router.push({
            name: 'projects-list',
            query: { editorId },
          })
          break
        }
        default: {
          this.$router.push('/')
          break
        }
      }

      this.leaveType = ''
      this.popupActive = ''
    },
    // 退出提示弹窗
    onExecution() {
      this.popupActive = 'execution'
    },
    // 退出提示确认
    //防抖函数
    executionProject: debounce(function(type) {
      // this.$router.go(-1)
      this.$router.push({name: 'home'});
    }, 300),
    // 取消弹窗
    cancelPopup(val) {
      this.popupActive = ''
      this.scoreForm = ''
    },

    //获取积木列表接口
    getBlockList() {
      // let res = await AIBLOCK.getBlockList()
      return Promise.all([
        AIBLOCK.getModelBlockList(),
        AIBLOCK.getBlockList(),
      ]).then((values) => {
        // try {
        var Blocks = this.Blocks
        let blocksList = []
        for (let i = 0, len = values.length; len > 0 && i < len; i++) {
          if (values[i] && values[i].data && values[i].data instanceof Array) {
            blocksList = blocksList.concat(values[i].data)
          }
        }
        Blocks.Items = blocksList
        if (!sessionStorage.getBlockList) {
          sessionStorage.getBlockList = JSON.stringify(blocksList)
        }
        // console.log('blocksList:', blocksList)
        this.Blocks = Blocks
        // } catch (e) {}
      })

      // if (res.isSuccess) {
      //   var Blocks = this.Blocks
      //   Blocks.TotalCount = res.data.length
      //   Blocks.Items = res.data
      //   if(!sessionStorage.getBlockList){
      //     sessionStorage.getBlockList =JSON.stringify(res.data)
      //   }
      //   this.Blocks = Blocks
      // }
      // return res
    },

    //获取积木列表接口---我的模型、公共模型部分
    async getModelBlockList() {
      return AIBLOCK.getModelBlockList()
    },
    /**
    获取个人空间项目详情数据 @data projectId
  */
    async getProjectByProjectId() {
      let res,
        data = {
          projectId: this.projectId,
        }

      res = await PERSONAL.getProjectByProjectId(data)
      if (res.isSuccess) {
        try {
          this.blockXmlText = res.data.buildingBlocks

          this.Project = res.data
        } catch (e) {
          console.log(e)
        }
      }
      return res
    },

    //保存项目文件功能 runType 保存或者是另存为，显示提示不一样
    async saveFile(id) {
      if (!this.projectId) return

      var xml = this.$refs.blocklyIndex.$refs.blockly.workspaceToDom(), //工作台上的积木
        projectId = id || this.projectId,
        data = {},
        result,
        msg = id ? '保存成功' : '保存成功',
        pythonCodeText = this.codeText

      data = {
        buildingBlocks: xml.outerHTML,
        projectId,
      }
      result = await PERSONAL.saveProjectCode(data)
      if (result && result.isSuccess) {
        this.$message.success(result.returnMsg)
      } else if (result) {
        this.$message.error(result.returnMsg)
      }
      return result
    },
    //获取媒体（图片、音频、文本）资源
    getMedia() {
      let { projectId } = this,
        data = {}

      if (projectId) {
        //ai-T编辑器里根据trainingId获取媒体积木
        data = {
          projectId,
        }

        return AI_EDITOR.getMediaByTrainingId(data).then((result) => {
          if (result.isSuccess) {
            this.Media = result.data
            //图片列表
            this.mediaGotten = 1
          }
        })
      }
    },
    runHandle() {
      this.$refs.blocklyIndex.$refs.blockly.runHandle()
    },

    // UI rating star
    UIRatingStarshow(idx, rate) {
      let result = ''
      if (rate - idx >= 1) {
        result = 'icon-star-entire'
      } else if (rate - idx >= 0.5) {
        result = 'icon-star-half'
      }
      return result
    },
    // 重绘工作区大小
    sidebarSwitchHandle(switchObj) {
      this.sidebarSwitch = switchObj.sidebarSwitch
      // bus.$emit('onSidebarSwitch')
      // if (window) {
      //   this.$nextTick(() => {
      //     // window.dispatchEvent(new Event("resize"));
      //     var resizeEvent = window.document.createEvent('UIEvents')
      //     resizeEvent.initUIEvent('resize', true, false, window, 0)
      //     window.dispatchEvent(resizeEvent)
      //   })
      // }
    },
  },
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
$head_height: 80px;
$blockly_editer_left: rgba(13, 22, 53, 0.5);
$blockly_editer_left_select: rgba(12, 21, 52, 0.9);
$bg_area_right: rgba(94, 147, 255, 0.1);
$bg_tool_button: rgba(103, 140, 255, 0.15);
$height_sidebar_item: calc(50% - 80px);
$high_ligth: #886efa;

.on {
  display: inline-block;
}

.off {
  display: none;
}

// @media screen and (orientation: portrait) {
//   // html {
//   //   width: 100%;
//   //   height: 100%;
//   //   background-color: white;
//   //   overflow: hidden;
//   // }
//   // body {
//   //   width: 100%;
//   //   height: 100%;
//   //   overflow: hidden;
//   // }
//   // #print {
//   //   position: absolute;
//   // }
//   #print {
//     width: 100%;
//     height: 100%;
//     position: absolute;
//     overflow: hidden;
//   }
// }
// @media screen and (orientation: landscape) {
//   // html {
//   //   width: 100%;
//   //   height: 100%;
//   //   background-color: white;
//   // }
//   // body {
//   //   width: 100%;
//   //   height: 100%;
//   //   background-color: white;
//   // }
//   // #print {
//   //   position: absolute;
//   //   top: 0;
//   //   left: 0;
//   //   width: 100%;
//   //   height: 100%;
//   // }
//   #print {
//     width: 100%;
//     height: 100%;
//     position: absolute;
//     top: 0;
//     left: 0;
//   }
// }

.training {
  min-height: 100%;
  height: 100%;
  background-color: #08102c;
  background-image: url('../../../../public/images/projects/bg_training.png');
  background-size: cover;
  background-position: center;
  color: $font_color_1st;
  // overflow: hidden;
}

.training-area {
  // MARK:此处可能会有隐患
  overflow: hidden;
  position: relative;
  // height: 100%;
  height: calc(100% - 80px);

  // 代码模式
  &::v-deep .code-editer {
    color: #fff;
  }
}

.switch-btn {
  // display: inline;
  position: fixed;
  right: 26px;
  bottom: 38px;
  width: 36px;
  height: 36px;
  cursor: pointer;
  z-index: 50;
  img {
    width: 100%;
    height: 100%;
  }
}

.submit-code-exercise {
  display: flex;
  justify-content: center;
  position: fixed;
  z-index: 8;
  bottom: 33px;
  left: calc(50% - 200px);
  transform: translateX(-50%);
  .submit-btn {
    display: flex;
    align-items: center;
    margin: 0 10px;
    padding: 8px 20px;
    border-radius: 17px;
    background: rgba(52, 84, 164, 0.6);
    font-size: 14px;
    color: #fefeff;
    font-family: Microsoft YaHei;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      background: rgba(103, 140, 255, 0.6);
    }
    .text {
      margin-left: 10px;
    }
  }
}

.popup-list {
  .popup-leave-save,
  .popup-score,
  .popup-execution {
    z-index: 50;
    &.off {
      display: none;
    }
  }
  .popup-score {
    &::v-deep .popup-inner {
      width: 620px;
      height: 100%;
      max-height: 90%;
      .popup-content {
        margin-top: 20px;
        .el-form {
          width: 90%;
          .el-form-item {
            margin-bottom: 5px;
            &.strong-label {
              .el-form-item__label {
                font-weight: 600;
              }
            }
          }
        }
        // .score-text {
        //   // margin-top: 20px;
        // }
      }
    }
    ::v-deep.popup-inner {
      max-height: 80%;
      height: 800px;
      .popup-content {
        padding-top: 20px;
      }
    }
  }

  .popup-execution {
    z-index: 99;
    &::v-deep .popup-head {
      border-bottom: 0 none;
    }
    .popup-del-cnt {
      overflow: hidden;
      margin-top: -25px;
      .head {
        .icon-box {
          display: inline-block;
          margin-right: 12px;
          vertical-align: middle;
        }
        .title {
          display: inline-block;
          color: #333;
          vertical-align: middle;
        }
      }
      .content {
        margin-top: 20px;
        padding: 15px 0;
        text-align: center;
      }
    }
  }
}
.dispermited {
  pointer-events: none;
  opacity: 0.5;
}
</style>
